export { default as CategoriesIndexTable } from './CategoriesIndexTable';
